module.exports = __webpack_public_path__ + "static/img/企业合规管培养基地.57e8b0af.png";